<div class="wrapper relative">
  @if (isLoading()) {
    <korviu-loader></korviu-loader>
  }
  <div class="w-full mb-14 text-center">
    <span class="header text-center font-normal text-base md:text-lg">{{
      'profile.addAccount.addAccount' | translate
    }}</span>
  </div>
  <div class="w-full mb-14">
    <korviu-steps
      [steps]="['profile.addAccount.accountDetails', 'profile.addAccount.documentation']"
      [current]="step()"
    ></korviu-steps>
  </div>
  @if (step() === 0) {
    <app-bank-info
      [(bankInfo)]="addPaymentAccountData.bankInfo"
      (backClick)="onBankInfoBackClick()"
      (continueClick)="onBankInfoContinueClick()"
    ></app-bank-info>
  }
  @if (step() === 1) {
    <app-documentation
      [documentation]="addPaymentAccountData.documentation"
      [isUsAccount]="addPaymentAccountData?.bankInfo?.account_type === 'US'"
      (backClick)="onDocumentationBackClick()"
      (submitClick)="onDocumentationSubmitClick()"
    ></app-documentation>
  }
</div>
